import { Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import Breadcrumb from 'UiKit/breadcrumb';
import { TextBold } from 'UiKit/typography';

import StatusBadge from 'View/reschedule/component/status-badge';
import { getBreadcrumbItem } from 'View/reschedule-detail/helper/getBreadcrumbItem';

import styles from './styles.module.css';

const Head = ({ status, hostRequester }) => {
  const { t } = useTranslation('reschedule');
  const breadcrumbItems = getBreadcrumbItem(status, hostRequester, t);
  return (
    <Flex className={styles['head__container']}>
      <Breadcrumb items={breadcrumbItems} />
      <Box className={styles['title__cointainer']}>
        <TextBold className={styles['head__title']}>{t('formDetailTitle')}</TextBold>
        <StatusBadge status={status}>{status}</StatusBadge>
      </Box>
    </Flex>
  );
};

export default Head;